module.exports = __webpack_public_path__ + "static/media/approval.c203884e.svg";